module.exports = __webpack_public_path__ + "static/media/collapsearrow.3e3444b8.svg";